<template>
    <div>

        <!--导航栏 start-->
        <van-nav-bar
                title="申请提现"
                left-text="返回"
                @click-left="onClickLeft"
                left-arrow
                fixed
        />
        <!--导航栏 end-->
        <!--内容部分 start-->
        <van-form @submit="onSubmit" style="margin-top: 1.5rem">
            <van-field label="代理商" :value="list.agent.name" readonly />
            <van-field label="待提现金额" :value="list.agent.money" readonly />
            <van-field label="开户行" :value="list.agent.banks.s_zh" readonly />
            <van-field label="结算卡号" :value="list.agent.banks.s_kh" readonly />
            <van-field label="手机号" :value="list.agent.tel" readonly />
            <van-field
                    v-model="money"
                    name="提现金额"
                    label="提现金额"
                    type="number"
                    :placeholder="'提现金额不少于'+list.amount_level"
                    :rules="[{ required: true, message: '提现金额不能为空' }]"
            />
            <van-field
                    v-model="remark"
                    type="textarea"
                    name="备注信息"
                    label="备注信息"
                    placeholder="请输入备注信息"
            />
        </van-form>
        <div style="margin: 16px;">
            <van-button @click="onSubmit" round block type="info" native-type="submit">
                确定
            </van-button>
        </div>
        <!--内容部分 end-->


    </div>
</template>

<script>
    // import VueCookie from 'vue-cookies'
    import {Notify, Toast} from 'vant';
    export default {
        name: "AgentLogin", //代理添加
        data() {
            return {
                money: '',
                remark: '',
                list:this.$route.query.list
            };
        },
        created() {
            console.log(this.list)
        },
        // 组件内路由--进入组件时
        beforeRouteEnter(to, from, next) {
            window.document.body.style.backgroundColor = '#f5f5f5';
            next();
        },
        // 组件内路由--离开组件时
        beforeRouteLeave(to, from, next) {
            window.document.body.style.backgroundColor = '';
            next();
        },
        methods: {
            // 左侧返回
            onClickLeft() {
                this.$router.push("/MyAccount");
                // window.history.go(-1)
            },
            // 提交
            onSubmit() {
                // window.sessionStorage.setItem("tag",this.ta)
                //  var that = this;
                var toast = Toast.loading({
                    duration: 0,
                    message: '申请中...',
                    forbidClick: true,
                    loadingType: 'spinner',
                });
                // console.log('submit', values);
                this.$http.get('/wechat/api.agent.money/apply', {
                    params: {
                        money: this.money,
                        remark: this.remark,
                        // openid: window.localStorage.getItem("openid")
                    }
                }).then(response => {
                    toast.clear();
                    console.log(response.data);
                    if (response && response.data.code== 200) {
                        Notify({type: 'success', message: response.data.msg});
                        this.$router.push("/MyAccount");
                        // VueCookie.set('salesmanInfo', response.data.data, 360000);
                        // window.location.href = that.redirect;

                    }else{
                        Notify({type: 'danger', message: response.data.msg});
                    }
                })



            },
        },
    }
</script>

<style >
    .van-icon-goods-collect-o::before{
        position: relative;
        top: 0.1rem;
    }
    .van-icon-contact::before{
        position: relative;
        top: 0.1rem;
    }
</style>
